module.exports = __webpack_public_path__ + "media/images/freelogodesign1_green-d98520f0cd238ff30f42fec953914194.png";